import { IndexedDb } from "./indexDB";
const REQUEST_TABLE = "requests";
/**
 * Represents a cache request manager that interacts with IndexedDb.
 * @class
 */
export class CacheRequest {
    constructor() {
        this.get = async (key, cache) => {
            if (this.indexedDb) {
                if (cache) {
                    const cachedData = await this.indexedDb.getValue(REQUEST_TABLE, key);
                    if (cachedData) {
                        const hours = typeof cache === "number" ? cache : 24;
                        const { requestDate, value } = cachedData;
                        if (requestDate > Date.now() - hours * 3600000) {
                            return value;
                        }
                    }
                }
                else {
                    this.indexedDb.deleteValue(REQUEST_TABLE, key).then();
                }
            }
            return null;
        };
        this.set = async (id, value) => {
            if (this.indexedDb) {
                const data = {
                    value,
                    id,
                    requestDate: Date.now(),
                };
                await this.indexedDb.putValue(REQUEST_TABLE, data);
            }
        };
        this.indexedDb = new IndexedDb("cacheRequests", REQUEST_TABLE);
    }
}
